import { components } from "./components";
import { typography } from "./typography";
import { blue, marron, paste, primary, themeColors, orange, bluish, success, warning, gold } from "./theme-colors";
const THEMES = {
  GIFT: "GIFT",
  BACKEND: "HEALTH",
  DEFAULT: "DEFAULT",
  GROCERY: "GROCERY",
  PASTE: "PASTE",
  ORANGE: "ORANGE",
  GOLD: "GOLD",
  BLUISH: "BLUISH",
  GREEN: "GREEN",
  YELLOW: "YELLOW"
};
const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1600,
    xxl: 1920
  }
};
/*
WE CREATED MULTIPLE THEME OPTIONS FOR DIFFERENT SHOP VARIATION.

YOU CAN JUST KEEP [THEMES.DEFAULT] AND REMOVE OTHER THEME OPTIONS.
*/

export const themesOptionList = {
  [THEMES.DEFAULT]: {
    typography,
    components,
    breakpoints,
    palette: {
      primary: { ...primary,
        light: primary[100]
      },
      ...themeColors
    }
  },
  [THEMES.BACKEND]: {
    typography,
    components,
    breakpoints,
    palette: {
      primary: { ...primary,
        light: primary[100]
      },
      ...themeColors
    }
  },
};

const themeOptions = pathname => {
  let themeOption;
  /*
    YOU CAN ALSO REMOVE updateTheme function
    AND FOLLOWING ENTIRE switch case BLOCK.
  */

  const updateTheme = themeName => {
    themeOption = themesOptionList[themeName];
  };

  switch (pathname) {
    case "/":
      updateTheme(THEMES.DEFAULT);
      break;
    default:
      if (pathname.startsWith("/admin") || pathname.startsWith("/vendor")) {
        themeOption = themesOptionList[THEMES.BACKEND];
      } else {
        themeOption = themesOptionList[THEMES.DEFAULT];
      }

      break;
  }
  /*
        IF YOU REMOVE THE switch case, YOU NEED TO ASSIGN VALUE TO themeOptions
        E.G. themeOption = themesOptions[THEMES.DEFAULT];
    */

// themeOption = themesOptions[THEMES.DEFAULT];


  return themeOption;
};

export default themeOptions;
